import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Competencies } from './components/Competencies';
import { CareerTimeline } from './components/CareerTimeline';
import { Credentials } from './components/Credentials';
import { ContactFooter } from './components/ContactFooter';
export function App() {
  return <div className="min-h-screen w-full bg-canvas font-sans" data-id="element-0" data-mp="2rlyr0hc56qkk">
      <SiteHeader data-id="element-1" data-mp="2mluawsf5bxuv" />
      <main data-id="element-2" data-mp="2mmcbu2cr7094">
        <Hero data-id="element-3" data-mp="2mmvl6uoc8gbj" />
        <StatsBar data-id="element-4" data-mp="2mn5fgugf19n1" />
        <Competencies data-id="element-5" data-mp="2mnne1xqjvzy4" />
        <CareerTimeline data-id="element-6" data-mp="31aqfuglwour9" />
        <Credentials data-id="element-7" data-mp="31aysc7e49y1x" />
      </main>
      <ContactFooter data-id="element-8" data-mp="31c9u61o04vqe" />
    </div>;
}